import * as React from "react";
import {PolicyNameEnum} from "../PolicyNameEnum";
import {ICustomerWithPolicy} from "@Safemate/Model/Customer";

export const CustomerSettingsContext = React.createContext({});

export const CustomerSettingsConsumer = CustomerSettingsContext.Consumer;

export interface CustomerSetting{
  climaxConfig: boolean;
}

export interface CustomerSettings{
  [index: number]: CustomerSetting;
}

interface SettingsProviderProps{
  customers: ICustomerWithPolicy[];
}

export const CustomerSettingsProvider = ({customers, children}: React.PropsWithChildren<SettingsProviderProps>) => {

  const settings: CustomerSettings = {}
  customers.forEach(customer => {
    settings[customer.customerId] = {
      climaxConfig: customer.climaxConfig
    }
  })

  return(
    <CustomerSettingsContext.Provider value={settings}>
      {React.Children.only(children)}
    </CustomerSettingsContext.Provider>
  )
}